import React from "react";
import "../styles/navbar.scss";
import { ConnectKitButton } from "connectkit";
const Navbar = () => {
  return (
    <div className="navbar">
      <div className="container">
        <div className="logo">
          <img src="/images/litho-icon.svg" alt="logo" className="desktop" />
          <img src="/images/litho-icon.svg" alt="logo" className="mobile" />
        </div>
        <div className="right-content">
          <ConnectKitButton/>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
